export default __webpack_public_path__ + "static/media/GoogleFirmImg.8be9f9af.png";